// path: frontend/src/components/pages/admin/models/DeleteModal.jsx
import React from 'react';

const DeleteModal = ({ open, onClose, onConfirm, title = 'Delete', description = '', confirmText = 'Delete' }) => {
  if (!open) return null;
  return (
    <div className="delete-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="delete-modal-container bg-bg-60 rounded-xl shadow-xl p-6 w-full max-w-sm relative">
        <h2 className="text-lg font-bold text-fg-50 mb-2">{title}</h2>
        {description && <p className="text-sm text-fg-60 mb-4">{description}</p>}
        <div className="flex justify-end gap-2 mt-6">
          <button
            className="px-4 py-2 rounded-md bg-bg-40 text-fg-60 hover:bg-bg-50 text-sm font-medium"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-md text-white dark:text-black  text-sm font-medium bg-ac-02 hover:bg-ac-01"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal; 